import React from 'react';

import Header from '../../layout/header/Header';
import { useAuthContext } from '../../context/auth';
import { SignIn } from './signIn';
import { ForgotPassword } from './forgotPassword';
import { RequireNewPassword } from './requireNewPassword';
import { dispatchAuthStateChangeEvent, isSupportedAuthState, SupportedAuthState, AuthState, AuthStateType } from './utils';

export const components: { [k in SupportedAuthState]: () => JSX.Element } = {
  [AuthState.SignIn]: SignIn,
  [AuthState.ForgotPassword]: ForgotPassword,
  [AuthState.ResetPassword]: RequireNewPassword
};

// Returns a 1-tuple (rather than the component directly) so it can be array-destructured at the
// call site - eslint's react-hooks/static-components rule flags a plain `const Component =
// getCurrent(...)` assignment as "creating a component during render", even though this is just
// selecting a stable, already-defined component from the `components` map.
const getCurrent = (authState: AuthStateType): [typeof components[SupportedAuthState]] => {
  if (isSupportedAuthState(authState)) {
    return [components[authState]];
  }
  throw new Error(`authState ${authState} is not supported`);
};

export const Authenticator = () => {
  const { authState } = useAuthContext();

  const goToSignIn = () => {
    if (authState !== AuthState.SignIn) {
      dispatchAuthStateChangeEvent(AuthState.SignIn);
    }
  };

  const [Component] = getCurrent(authState);
  return <>
    <Header onLogoClick={goToSignIn} />
    <Component />
  </>;
};
